import React from 'react';
import { ReactComponent as Transfer } from 'images/transfer.svg';
import { ReactComponent as BlueTransfer } from 'images/blue-transfer-icon.svg';
import { ReactComponent as Profile } from 'images/profile.svg';
import { ReactComponent as Secure } from 'images/lock.svg';

export interface DescriptionItem {
  description: string | null;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const descriptionItems: DescriptionItem[] = [
  {
    description: 'Retrieves your account and routing number for depositing your funds and making payments.',
    icon: Transfer,
  },
  {
    description: 'Verifies your identity and income.',
    icon: Profile,
  },
  {
    description: null,
    icon: BlueTransfer,
  },
  {
    description: 'Uses bank level security protocols.',
    icon: Secure,
  },
];

export const aiCoachDescriptionItems: DescriptionItem[] = [
  {
    description: 'Track your income and expense',
    icon: Transfer,
  },
  {
    description: 'Automate your savings',
    icon: Profile,
  },
  {
    description: 'Uses bank level security protocols',
    icon: Secure,
  },
];

export const incomeVerificationDescriptionItems: DescriptionItem[] = [
  {
    description: 'Confirms your income through bank transactions.',
    icon: Profile,
  },
  {
    description: 'Uses bank level security protocols.',
    icon: Secure,
  },
];
